module.exports = __webpack_public_path__ + "static/media/1016940.1a9695e9.jpg";